import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
  ButtonToolbar,
  Button,
} from 'reactstrap';
import DateField from '../../../shared/components/form/DateField';
import renderDropZoneField from '../../../shared/components/form/DropZone';
import { useSmartContext } from '../../App/context/SmartProvider';

function VaccineApplicationInformationModal(props) {
  const { t, toggle, modal, title, VaccinesReportedQuantity, updateVaccines } =
    props;
  const { loggedUser } = useSmartContext();
  const [observations, setObservations] = useState('');
  const [receipt, setReceipt] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const observationChangeHandler = (evt) => {
    setObservations(evt.target.value);
  };

  const receiptChangeHandler = (rec) => {
    setReceipt(rec);
  };

  const onChangeDate = (date) => {
    setSelectedDate(date);
  };
  const saveVaccines = () => {
    const updatedVaccines = {
      applicationDate: selectedDate.getTime(),
      file: receipt,
      additionalInformation: observations || null,
    };
    updateVaccines(updatedVaccines);
  };

  useEffect(() => {
    setObservations('');
    setSelectedDate(new Date());
    setReceipt([]);
  }, [modal]);

  return (
    <Modal isOpen={modal} toggle={toggle} className="theme-light">
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <form className="form">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('vaccination.VaccinesReported')}
            </span>
            <div className="form__form-group-field">
              <Label>{VaccinesReportedQuantity}</Label>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('vaccination.applicationDate')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="applicationDate"
                type="text"
                component={DateField}
                placeholder={t('vaccination.applicationDate')}
                onChange={onChangeDate}
                selected={new Date()}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('vaccination.informedBy')}
            </span>
            <div className="form__form-group-field">
              <Label>{loggedUser.name}</Label>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.observations')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="observation"
                type="text"
                component="textarea"
                maxLength="250"
                placeholder={t('general.observations')}
                value={observations}
                onChange={observationChangeHandler}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('vaccination.receipt')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="file"
                type="text"
                component={renderDropZoneField}
                placeholder={t('vaccination.receipt')}
                value={receipt}
                onChange={receiptChangeHandler}
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <ButtonToolbar>
          <Button color="success" onClick={saveVaccines}>
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </ModalFooter>
    </Modal>
  );
}

VaccineApplicationInformationModal.propTypes = {
  t: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  title: PropTypes.string,
  VaccinesReportedQuantity: PropTypes.number.isRequired,
  updateVaccines: PropTypes.shape(PropTypes.shape).isRequired,
};

VaccineApplicationInformationModal.defaultProps = {
  title: '',
};

export default reduxForm({
  form: 'VaccineApplicationInformationModal',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(VaccineApplicationInformationModal));
